module.exports = __webpack_public_path__ + "static/media/info-icon.ea9929c4.svg";